export var SECTION_LINE_WIDTH = 1;
export var SECTION_HOVERED_LINE_WIDTH = 2;
export var SECTION_SELECTED_LINE_WIDTH = 2;
export var ROW_LINE_WIDTH = 1;
export var ROW_HOVERED_LINE_WIDTH = 2;
export var ROW_SELECTED_LINE_WIDTH = 2;
export var HIGHLIGHTED_LINE_WIDTH = 2;

// Default color schema
export var COLOR_TRANSPARENT = 'rgba(0,0,0,0)';
export var COLOR_BACKGROUND = '#FFFFFF';
export var COLOR_DISABLED_FILL = '#E6E6E6';
export var COLOR_DISABLED_STROKE = '#C8C8C8';
export var COLOR_TEXT = '#000000';
export var COLOR_TEXT_SHADOW = 'hsla(0,0%,100%,0.3)';
export var COLOR_INACTIVE_FILL = '#d3d3dc';
export var COLOR_INACTIVE_STROKE = '#FFF';
export var COLOR_AVAILABLE_FILL = '#7CC6FF';
export var COLOR_AVAILABLE_STROKE = '#398CD7';
export var COLOR_HOVERED_FILL = '#f7b4df';
export var COLOR_SELECTED_FILL = '#f7b4df';
export var COLOR_SELECTED_STROKE = '#ce3197';
export var COLOR_HIGHLIGHTED_STROKE = '#ce3197';
export var DEFAULT_COLORS = {
  // Global
  background: COLOR_BACKGROUND,
  'venue-fill': COLOR_INACTIVE_FILL,
  'venue-stroke': COLOR_INACTIVE_STROKE,
  'highlighted-stroke': COLOR_HIGHLIGHTED_STROKE,
  // Text
  label: COLOR_TEXT,
  'section-label': COLOR_TEXT,
  'row-label': COLOR_TEXT,
  // Disabled seatings
  'seating-disabled-fill': COLOR_DISABLED_FILL,
  'seating-disabled-stroke': COLOR_DISABLED_STROKE,
  // Row
  'row-available-fill': COLOR_AVAILABLE_FILL,
  'row-available-stroke': COLOR_AVAILABLE_STROKE,
  'row-hovered-fill': COLOR_HOVERED_FILL,
  'row-hovered-stroke': COLOR_AVAILABLE_STROKE,
  'row-selected-fill': COLOR_SELECTED_FILL,
  'row-selected-stroke': COLOR_SELECTED_STROKE,
  // Section
  'section-available-fill': COLOR_AVAILABLE_FILL,
  'section-available-stroke': COLOR_AVAILABLE_STROKE,
  'section-hovered-fill': COLOR_HOVERED_FILL,
  'section-hovered-stroke': COLOR_AVAILABLE_STROKE,
  'section-selected-fill': COLOR_SELECTED_FILL,
  'section-selected-stroke': COLOR_SELECTED_STROKE
};
export var MAP_CONTAINER_CLASS = 'vs-venue-map-container';
export var ROW_ZOOM_OFFSET = 2;
export var CAMERA_PITCH = 45;
export var ZOOM_IN_THRESHOLD = 4;
export var CAMERA_ZOOM_DURATION = 500;
export var CAMERA_FOCUS_DURATION = 1000;
export var CAMERA_RESET_DURATION = 1000;
export var SEATING_ID_PATTERN = /^[a-z\d]+(?:-[a-z\d]+)*(?::[a-z\d]+)?$/;
export var MAX_BOUNDS_PADDING = 0.5;
/***
 * Former FOCUS_ROW_ZOOM_OFFSET value was 0.25 for dynamic zoom level logic.
 * Opted for consistent zoom levels with logic behind src/components/VenueMap/classes/VenueMapController/class.ts
***/
export var FOCUS_ROW_ZOOM_OFFSET = 1.25;
export var NUMERIC_DIFF_THRESHOLD = 0.000001;
export var DISTANCE_DIFF_THRESHOLD = 0.001;
export var DEFAULT_CURSOR = "\n        <svg\n            class=\"vs-default-cursor\"\n            enable-background=\"new 0 0 42 42\"\n            version=\"1.1\"\n            viewBox=\"0 0 42 42\"\n            xml:space=\"preserve\"\n            xmlns=\"http://www.w3.org/2000/svg\"\n        >\n            <polygon points=\"42 20 22 20 22 0 20 0 20 20 0 20 0 22 20 22 20 42 22 42 22 22 42 22\" />\n        </svg>\n";
export var SOURCE_ID = 'base';
export var SOURCE_LAYER = 'base';
export var DEFAULT_MAP_LAYOUT = 'https://d2d6ul3tefw3xz.cloudfront.net/staging/venue-maps/layouts/5/62_1572448851/';
export var MAP_NOT_READY_ERROR = 'Map has not been initialized.';
export var MOBILE_CUT = 700;
export var NUMERIC_PRECISION = 0;
export var WATERMARK_ALT = 'Powered by Vivid Seats';
export var WATERMARK_HREF = 'https://vividseats.com';
export var WATERMARK_SRC = './powered-by-vs.png';
export var FX_AVAILABLE_FILL = '#5ED9C9';
export var FX_AVAILABLE_STROKE = '#54C0B1';
export var FX_HOVERED_STROKE = '#F96B5D';
export var FX_SELECTED_FILL = '#FB8F85';
export var availableSchemas = {
  fanxchange: {
    'highlighted-stroke': FX_HOVERED_STROKE,
    // Row
    'row-available-fill': FX_AVAILABLE_FILL,
    'row-available-stroke': FX_AVAILABLE_STROKE,
    'row-hovered-fill': FX_AVAILABLE_FILL,
    'row-hovered-stroke': FX_HOVERED_STROKE,
    'row-selected-fill': FX_SELECTED_FILL,
    'row-selected-stroke': FX_HOVERED_STROKE,
    // Section
    'section-available-fill': FX_AVAILABLE_FILL,
    'section-available-stroke': FX_AVAILABLE_STROKE,
    'section-hovered-fill': FX_AVAILABLE_FILL,
    'section-hovered-stroke': FX_HOVERED_STROKE,
    'section-selected-fill': FX_SELECTED_FILL,
    'section-selected-stroke': FX_HOVERED_STROKE
  },
  "default": {}
};
export var CAMERA_CONTROL_ZOOM_IN_ICON = "\n    <svg\n        class=\"vs-venue-map-camera-control-icon\"\n        xmlns=\"http://www.w3.org/2000/svg\"\n        version=\"1.1\"\n        viewBox=\"0 0 64 64\"\n    >\n        <polygon\n            fill=\"#000000\"\n            points=\"58.1,29 35,29 35,5.9 29,5.9 29,29 5.9,29 5.9,35 29,35 29,58.1 35,58.1 35,35 58.1,35\"\n        />\n    </svg>\n";
export var CAMERA_CONTROL_ZOOM_OUT_ICON = "\n    <svg\n        class=\"vs-venue-map-camera-control-icon\"\n        xmlns=\"http://www.w3.org/2000/svg\"\n        version=\"1.1\"\n        viewBox=\"0 0 64 64\"\n    >\n        <polygon fill=\"#000000\" points=\"58.1,29 5.9,29 5.9,35 58.1,35\" />\n    </svg>\n";
export var CAMERA_CONTROL_RESET_ICON = "\n    <svg\n        class=\"vs-venue-map-camera-control-icon\"\n        xmlns=\"http://www.w3.org/2000/svg\"\n        version=\"1.1\"\n        viewBox=\"0 0 64 64\"\n    >\n        <path\n            fill=\"#000000\"\n            d=\"M54.4,34.8C53,45.4,44,53.6,33,53.6c-7,0-13.3-3.4-17.2-8.6l-4.4,4.4c-0.6,0.6-1.7,0.2-1.7-0.7 V34.8h13.9c0.9,0,1.4,1.1,0.7,1.7L20,40.8c2.8,4.2,7.6,6.9,13,6.9c7.7,0,14.1-5.6,15.4-12.9H54.4z M52.6,14.6L48.2,19 c-3.9-5.2-10.2-8.6-17.2-8.6c-11,0-20,8.2-21.4,18.8h6c1.3-7.3,7.7-12.9,15.4-12.9c5.4,0,10.2,2.7,13,6.9l-4.3,4.3 c-0.6,0.6-0.2,1.7,0.7,1.7h13.9V15.3C54.4,14.4,53.3,14,52.6,14.6z\"\n        />\n    </svg>\n";
export var DEFAULT_CLICK_BEHAVIOR = {
  animate: true,
  focus: true,
  faceStage: true
};